<template>
	<div>
		<p>
			{{
				selectRandom([
					"We are going to performed a",
					"We are planning to perform a ",
					"We aim to perform a "
				])
			}}
			{{
				$tera.project.TrialWizard.trialType == "other"
					? checkString($tera.project.TrialWizard.trialTypeOther)
					: checkString($tera.project.TrialWizard.trialType)
			}}
			trial.
			<!-- {{ selectRandom(["The trial design description includes "]) }}
			{{
				joinArrayWithAnd($tera.project.trialDesign)
			}} -->
			{{ selectRandom(["The study power of the trial was"]) }}
			{{
				$tera.project.TrialWizard.studyPower == "other"
					? checkString($tera.project.TrialWizard.studyPowerOther)
					: checkString($tera.project.TrialWizard.studyPower)
			}}
			{{ selectRandom(["and the level of significance was"]) }}
			{{
				$tera.project.TrialWizard.levelOfSignificance == "other"
					? checkString($tera.project.TrialWizard.levelOfSignificanceOther)
					: checkString($tera.project.TrialWizard.levelOfSignificance)
			}}.
			{{
				selectRandom([
					"We are using a sample size of ",
					"We are aiming to use a sample size of ",
					"We want to use a sample size of ",
					"Our aim is to use a sample size of "
				])
			}}
			{{ checkString($tera.project.TrialWizard.sampleSize) }}.
			{{
				selectRandom([
					"The study should be powered for",
					"The research is to be powered for ",
					"The research will be powered for "
				])
			}}
			{{ checkString($tera.project.TrialWizard.effectSize) }}.
			{{
				selectRandom([
					"The expected proportion of participant drop-outs in the trial is",
					"The anticipated proportion of participants who will withdraw from the trial is ",
					"The trial's anticipated dropout percentage is ",
					"We anticipate a drop-out proportion of "
				])
			}}
			{{ checkString($tera.project.TrialWizard.participantDropOuts) }}.
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputSampleSize",
	mixins: [OutputMixin]
};
</script>
